
import Vue, { watch } from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { moneyFormatter } from "../utils";
import { Watch } from "vue-property-decorator";
import NumberInput from "@/components/wmc/NumberInput.vue";
import LoginRequired from "@/components/LoginRequired.vue";
import {
  ComercialGeralConfig,
  EstoqueConfig,
} from "../../interfaces/Comercial";
import ModalMessage from "@/components/wmc/Modals/ModalMessage.vue";
import { PedidoProduto } from "../../interfaces/Pedido";
import {
  calcular_estoque_diponivel_unidade_medida,
  calcular_preco_quantidade_minima,
  calcular_preco_unidade_medida,
  calcular_quantidade_unidade_medida,
} from "../../services/ProdutosService";
import ProdutoUnidadeMedidaChipSelector from "./ProdutoUnidadeMedidaChipSelector.vue";
import NumberButtonInput from "@/components/wmc/NumberButtonInput.vue";
import { event } from "vue-gtag";

const Auth = namespace("Auth");
const PedidoStore = namespace("Pedido");
const Notifications = namespace("Notifications");
const AppConfigStore = namespace("AppConfig");

@Component({
  name: "ProdutoQtdeContainer",
  components: {
    NumberInput,
    LoginRequired,
    ModalMessage,
    ProdutoUnidadeMedidaChipSelector,
    NumberButtonInput,
  },
  props: {
    isCard: {
      type: Boolean,
      default: false,
    },
    produto: {
      type: Object as () => PedidoProduto,
    },
    smallSize: {
      type: Boolean,
      default: false,
    },
  },
})
export default class ProdutoQtdeContainer extends Vue {
  isAddingToCart = false;
  private isRemoving = false;

  @AppConfigStore.Getter
  getConfigComercialGeral!: ComercialGeralConfig;

  @AppConfigStore.Getter
  private getConfigEstoque!: EstoqueConfig;

  @Auth.Getter
  private isLoggedIn!: boolean;

  @PedidoStore.Getter
  private getPedido!: any;

  @PedidoStore.Action
  private addProduto!: (payload: {
    produto: any;
    quantidade?: number;
    unidadeMedida?: string;
  }) => Promise<boolean>;

  @PedidoStore.Action
  private alterarUnidadeMedidaProduto!: (payload: {
    produtoId: string;
    unidade: string;
  }) => Promise<any>;

  @PedidoStore.Action
  private removerProduto!: (produtoId: string) => void;

  @PedidoStore.Action
  subtractProduto!: (payload: { produto: any; quantidade?: number }) => void;

  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  @Notifications.Action
  showInfoMessage!: (message: string) => Promise<any>;

  private selectedUn = "";
  private quantidade = 1;

  analytics() {
    event("add_to_cart", {
      items: [
        {
          id: this.localProduto.id,
          name: this.localProduto.descricao_portal,
          category: this.categoria,
          quantity: this.quantidade,
        },
      ],
    });
  }

  get categoria() {
    const grupo = this.localProduto?.grupo?.descricao || "";
    const subgrupo = this.localProduto?.subgrupo?.descricao || "";

    if (grupo && subgrupo) {
      return `${grupo}, ${subgrupo}`;
    }

    return grupo || subgrupo || "Não informado";
  }

  get localProduto() {
    return this.$props.produto;
  }

  get pedidoProduto() {
    return this.getPedido.produtos?.find(
      (el) => el.produto.id === this.localProduto.id
    );
  }

  get quantidadePedido() {
    return +this.pedidoProduto?.quantidade || 0;
  }

  get menorUnidade() {
    if (!this.localProduto?.unidadesMedida?.length) return "";

    // primeira unidade de medida de menor valor
    const unidade_menor = this.localProduto?.unidadesMedida?.reduce(
      (prev, current) => {
        return prev.fatorQtde < current.fatorQtde ? prev : current;
      }
    )?.descricao;

    return unidade_menor;
  }

  get maxQuantidade() {
    const exibir_estoque = this.getConfigEstoque?.exibir_estoque;
    const estoque_disponivel = this.localProduto?.estoque?.[0]?.estoque_disponivel || 0;

    if (!exibir_estoque) return undefined;

    const estoque = calcular_estoque_diponivel_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      estoque_disponivel,
      unidadeMedida: this.selectedUn,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
    });
    
    return estoque;
  }

  get precoMenorUnidade() {
    if (!this.localProduto?.unidadesMedida?.length) return "";

    // primeira unidade de medida de menor valor
    const unidade_menor = this.localProduto?.unidadesMedida?.reduce(
      (prev, current) => {
        return prev.fatorQtde < current.fatorQtde ? prev : current;
      }
    )?.id;

    const preco_unit = calcular_preco_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      preco_unit:
        +this.localProduto.promocao?.[0]?.precoUnit ||
        +this.localProduto.precosVenda?.[0]?.precoUnit,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: unidade_menor,
    });

    return moneyFormatter(preco_unit);
  }

  async removerProdutotest(produtoId: string) {
    this.isRemoving = true;
    try {
      await this.removerProduto(produtoId);
    } finally {
      this.isRemoving = false;
    }
  }

  moneyFormatter(value: number) {
    return moneyFormatter(value);
  }

  @Watch("quantidade")
  onQuantidadeChanged(value: number) {
    if (!this.$props.isCard) {
      this.quantidade = value || 1;
    }

    if (this.$props.isCard && this.quantidade != this.quantidadePedido) {
      this.adicionarProduto(value);
    }
  }

  @Watch("unidadeMedida")
  onUnidadeMedidaChanged(value: string) {
    this.selectedUn = value;
  }

  @Watch("quantidadePedido")
  onQuantidadePedidoChange(value: number) {
    this.quantidade = Number(value) || 1;
  }

  @Watch("pedidoProduto", { immediate: true, deep: true })
  onPedidoProdutoPropChanged(value) {
    this.quantidade = Number(this.pedidoProduto?.quantidade) || 1;

    this.selectedUn = this.unidadeMedidaAtual;
  }

  get precoUnitarioWithUnidadeMedida() {
    const preco_unitario_fator = calcular_preco_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      preco_unit:
        +this.localProduto.promocao?.[0]?.precoUnit ||
        +this.localProduto.precosVenda?.[0]?.precoUnit,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: this.selectedUn,
    });

    return (preco_unitario_fator || 0).toFixed(2);
  }

  get calcular_desconto_por_quantidade_minima() {
    const quantidade = calcular_quantidade_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      quantidade: +this.quantidade,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: this.selectedUn,
    });

    const valor = calcular_preco_quantidade_minima({
      preco_unit: +this.precoUnitarioWithUnidadeMedida,
      quantidade: +quantidade,
      lista_descontos: this.localProduto?.descQtdeMin,
    });

    return valor.toFixed(2);
  }

  get unidadeMedidaAtual() {
    const validUnidades: any[] = this.localProduto.unidadesMedida?.filter(
      (un: any) => un.situacao != "I"
    );

    // primeira unidade em ordem alfabética decrescente
    const primeiraUn = validUnidades?.reduce((prev, current) => {
      return prev.id > current.id ? prev : current;
    }, {} as any)?.id;

    // unidade do pedido
    let unPedido = this.pedidoProduto?.unidadeMedida;
    unPedido = validUnidades?.find((un: any) => un.id == unPedido)?.id;

    // unidade padrão do produto
    const unPadraoFator = validUnidades?.find(
      (un: any) => un.id == this.localProduto.unidadeMedida
    )?.id;

    return unPedido || unPadraoFator || primeiraUn;
  }

  get porcentagemPromocao() {
    const promocao = this.localProduto?.promocao;

    if (!promocao?.length) return 0;

    const valor_unit_promocao = promocao[0].precoUnit;
    const valor_unit_padrao = this.localProduto?.precosVenda?.[0]?.precoUnit;

    const porcentagem_desconto =
      100 - (+valor_unit_promocao * 100) / +valor_unit_padrao;

    if (porcentagem_desconto < 1) return 0;

    return Math.floor(porcentagem_desconto);
  }

  get hasDesconto() {
    return (
      +this.precoUnitarioPadrao > +this.calcular_desconto_por_quantidade_minima
    );
  }

  get precoUnitarioPadrao() {
    const preco_unitario_fator = calcular_preco_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      preco_unit: +this.localProduto.precosVenda?.[0]?.precoUnit,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: this.selectedUn,
    });

    return preco_unitario_fator;
  }

  async adicionarProduto(qtde: number) {
    this.isAddingToCart = true;

    await this.addProduto({
      produto: this.localProduto,
      unidadeMedida: this.selectedUn,
      quantidade: qtde,
    })
      // .then(() =>
      //   this.showInfoMessage(
      //     `PRODUTO ${this.localProduto.descricao} ADICIONADO`
      //   )
      // )
      .finally(() => (this.isAddingToCart = false));
  }

  @Watch("selectedUn")
  onSelectedUnChanged(value: string) {
    this.selectedUn = value;
    this.quantidade = 1;
    if (!this.$props.isCard) {
      return;
    }

    this.alterarUnidadeMedidaProduto({
      produtoId: this.localProduto.id,
      unidade: value,
    });
  }
}
